import { expVal } from '@confluence/feature-experiments';

// eslint-disable-next-line confluence-feature-gating/inline-usage
export const isProfileMacrosExperimentEnabled = () => {
	return expVal<boolean>('confluence_profile_macros_updates', 'isEnabled', false);
};
